export const DyLangId = {
    dashbordDy: {
        smsStats:'sms stats',
        totalsendnum:'terkirim total volume',
        selfsendnum:'Saya sendiri terkirim volume',
        contactsendnum:'Kontak terkirim volume',
        notickets:'Anda tidak memiliki tiket yang tertunda, harap ingatkan manajer untuk membagi tiket',
        NextCallTime:'Waktu panggilan berikutnya',
        unassign:'Apakah Anda yakin untuk membatalkan penetapan?',
        GenerateTicket:'Hasilkan   tiket',
        DialTheRecordingID:'Tekan ID rekaman',
        Collector:'Pengumpul',
        yes:"Ya",
        no:'Tidak',
        QualityInspector:"Inspektur kualitas",
        assigntime:'Waktu alokasi perintah kerja',
        startime:'Waktu mulai perintah kerja',
        completetime:'Waktu penyelesaian perintah kerja',
        normal:'normal',
        AbusiveCustomer:'Pelanggan yang kasar',
        sop:'Tidak memenuhi SOP',
        CustomerPromises:"Komitmen dan pengingat pelanggan tidak konsisten",
        CollectionInformation:'Informasi koleksi',
        QualityInspectionInformation:'Informasi pemeriksaan kualitas',
        Aging:'penuaan',
        HangUpReason:'Alasan untuk menutup telepon',
        DialTime:'Waktu panggil',
        recording:'rekaman',
        RecordingType:'Jenis rekaman',
        processResult:'hasil proses',
        queryConditions:'Harap isi setidaknya satu informasi kuer',
        characters:'Label tidak boleh melebihi 80 karakter.',
        ticketID:'ID Perintah Kerja Pemeriksaan Kualitas',
        RepaymentCode:'Kode pembayaran',
        RepaymentCodeChannel:'Saluran kode pembayaran',
        selectRepaymentCodeChannel:'Silakan pilih saluran kode pembayaran terlebih dahulu',
        Date:'Tanggal',
        CaseLevel:'Kaegori tiket',
        Totalorders:'Jumlah Pinjaman',
        NoWhatAppsnumber:'Tidak ada Nomor WhatsApp',
        HandleNumber:'Jumlah Penanganan',
        HandleNumberpercent:'Persentase pengingat',
        TotalUnconnected:"Total Tidak Terhubung",	
        Busy:"Sibuk",
        Reject:	"Ditolak",
        NotActive:	"Tidak Aktif",
        CustomerBlocked	:"Diblokir"	,
        ContinueRinging:"Berdering",	
        OutofCoverage:"Di Luar Jangkauan",	
        NotRegisterd:"Tidak Terdaftar",
        TotalConnected:	"Total Terhubung",
        NoMoney:	"Tidak Ada Uang"	,
        LeftMessagetoCP:'Menitipkan Pesan ke CP',
        WTP:'Pembayaran Sebagian',
        PartialPayment:	'Partial Payment',
        Rolling	:'Perpanjangan Tenor',
        BP:	"Melanggar Perjanjian Bayar",
        Underestimate:	'Meremehkan',
        DelayPayment:'Pembayaran Tertunda'	,
        subItem: 'Whether to divide the project',
        DataInvalid:'Data Tidak Sesuai'	,	
        NotCustomer:'Bukan Debitur',
        DidReceiveMoney:'Debitur Tidak Menerima Dana',
        Unconnected	:'Tidak Terhubung',
        Connected:'Connected',
        Pleaseentervaliddays:'Harap masukkan hari yang valid',
        recordingDuration:"durasi perekaman",
        MachineQuality:"Status pemeriksaan kualitas mesin",
        CollectionVoice:'Koleksi suara',
        salesman:"penjual",
        user:"pengguna",
        FinalQualityinspectionscore:"Skor pemeriksaan kualitas akhir",
        AIQualityInspectionScore:"Skor pemeriksaan kualitas AI",
        ManualQualityInspectionScore:"Skor pemeriksaan kualitas manual",
        triggerFragment:"fragmen pemicu",
        triggerRule:"aturan pemicu",
        ruleId:'id aturan',
        QualityInspectionType:"Jenis pemeriksaan kualitas",
        keywordsPhrases:'kata/kalimat',
        Score:"Skor",
        AIQualityInspectionConfiguration:'Konfigurasi pemeriksaan kualitas AI',
        keywordLibrary:'perpustakaan kata kunci',
        QCtext:'teks QC',
        QualityInspectionRules:'Aturan pemeriksaan kualitas',
        QualityInspectionTemplate:'Template pemeriksaan kualitas',
        newTalkPoint:"poin pembicaraan baru",
        founder:'pendiri',
        TalkPointName:"Nama perpustakaan kata",
        NumberOfSpeakingPoints:"Jumlah poin berbicara",
        RuleID:"ID Aturan",
        ruleName:"nama aturan",
        AddPoints:'Penambahan Poin',
        MinusPoints:'Pengurangan Poin',
        Scoring:"Penilaian",
        score:'skor',
        TheNumberOfQualityInspectionPoints:'Jumlah titik pemeriksaan kualitas',
        BasicInformation:"Informasi dasar",
        RulesDescription:'Deskripsi Aturan',
        numberofmatches:'jumlah pertandingan',
        QualityInspectionPoints:"Titik pemeriksaan kualitas",
        QCPointType:"jenis titik QC",
        QCobject:'Objek inspeksi kualitas',
        SpellPointHitRules:"Aturan Pukulan Spell Point",
        Within:"Dalam",
        consecutiveReplies:"balasan berturut-turut",
        Repeat :"Ulangi" ,
        times:"kali",
        AddQCpoint:'Tambahkan poin QC',
        Thelogical:"Hubungan logis antara titik pemeriksaan kualitas",
        or:'atau',
        and:"dan",
        
        templateName:"nama template",
        enabledstate:'status diaktifkan',
        Scopeofapplication:'Lingkup aplikasi',
        Containstherulebook:'Berisi jumlah aturan',
        Inclusionrules:'Aturan penyertaan',
        currentstate:'kondisi saat ini',
        Disable:'Cacat',
        addNewRules:'Aturan baru',
        TemplateDescription:'Deskripsi Templat',
        Qualityinspectionscoringitems:'Item penilaian pemeriksaan kualitas',
        Applicableaccountperiod:"Periode akun yang berlaku",
        Addaratingitem:'Tambahkan item peringkat',
        Talkingpointlibrary:'Perpustakaan titik bicara',
        artificial:"palsu",
        abandoned:'ditinggalkan',
        Obsolete:'Usang',
        Copywriting:'Koreksi kesalahan penulisan salin',
        Qualityinspectionlabel:'Label pemeriksaan kualitas',
        correctcopywriting:'copywriting yang benar',
        speechrecognitioncopywriting:'copywriting pengenalan ucapan',
        voiceclip:'bibir suara',
        return:'jalankan kembali',
        fix:"perbaiki",
        Nocorrectionrequired:"Tidak diperlukan koreksi",
        AIqualityinspectionstatus:'Status pemeriksaan kualitas AI',
        Manualqualityinspectionscore:"Skor pemeriksaan kualitas manual",
        AIqualityinspectionscore:'Skor pemeriksaan kualitas AI',
        WaktupemeriksaankualitasAI:"Waktu pemeriksaan kualitas AI",
        Notinspected:'Tidak diperiksa',
        Qualityinspected:'Kualitas diperiksa',

        unlimited:"tak terbatas",
        activated:"Sedang digunakan",
        terminated:"Telah diberhentikan",					
        scoreisrepeated:'Skor pemeriksaan kualitas diulang, harap verifikasi dan kirim ulang',
        finalscore:"nilai akhir",
        created:"dibuat",
        previouspage:'Konten yang Anda masukkan belum disimpan. Anda yakin kembali ke halaman sebelumnya?',
        continueediting:'Lanjut Edit',
        confirmreturn:'Konfirmasi Kembali',
        UpdateAIscore:"Perbarui skor AI",
        SpeechRecognitionCopywritinga:'Pengenalan suara Koreksi kesalahan penulisan salin',
        resultsafterwhile:'Skor AI telah diperbarui, silakan periksa hasilnya setelah beberapa saat',
        Enterkeywordstofilter:'Masukkan kata kunci untuk difilter',

        totalorder:"Gabungan pinjaman",
        Rolloverorder:'Nomor pinjaman yang dirolling',
        Suborder:'Pinjaman',
        ConfirmApplyForInterestFreeze: "Are you sure you want to apply for an interest freeze?",
        StatusOfApplyForInterestFreeze: "Apply for interest freeze status: ",
        unknownFreezeStatus: "unknown",
        canApplyForInterestFreeze: 'interest freeze can be applied for',
        interestFreezeing: 'interest Freezing',
        cannotApplyForInterestFreeze: 'interest freeze can not be applied for',
        GetQRcode:'Dapatkan kode QR',
        QRcodebelow:'Silahkan masuk ke WhatsApp dengan handphone Anda, dan memindai kode QR berikut untuk masuk ke WhatsApp',
        WhatsAppaccount:'Silahkan masukkan nomor handphone untuk masuk ke akun WhatsApp:',
        manual: 'Manual',
        automatic: 'Otomatis',
        import:'impor',
        BatchImport:'Impor Batch',
        callout:"memanggil",
        Unmark:"Hapus tanda",
        HandlingAdvice:'Saran penanganan',					
        callLabel:'label panggilan'	,	


        Isitarobot:"Apakah itu robot?",		
        Robotlabel:"Label robot",		
        nolabel:'tidak ada label'	,	
        inputMessage: 'masukkan pesan',		
        Promisedrepaymentamount:'Jumlah pengembalian yang dijanjikan',
        Dialogueerrorcorrection:"Koreksi kesalahan dialog",
        Modifyerrorcorrection:"Ubah koreksi kesalahan",
        notWAUser: 'Pihak lain bukan pengguna WhatsApp',
        notLoginWA: 'Akun saat ini tidak masuk ke WhatsApp',
        alreadyLoginWA: 'Anda masuk ke WhatsApp',
        pleaseSelectChat: 'Silakan pilih obrolan',
        emptyMessage: 'Pesan obrolan tidak boleh kosong',
        noTemplateMessage: 'Pesan khusus tidak didukung',
        hitstatement:"Nyataan pukulan",
        Identifycause:"Identifikasi penyebab kesalahan",		
    },


};
